import { GridItem, LayoutGrid, TypographyV3 } from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';

import SectionHeading from '@/app/components/SectionHeading';

const HowItWorksHero = (): JSX.Element => {
  const t = useTranslations();
  return (
    <section
      className="relative z-10 bg-sandstone-200"
      data-cy="how-it-works-hero"
    >
      <LayoutGrid className="pb-16 pt-36 md:pt-40">
        <GridItem
          colEnd={{ sm: 'main', lg: 12, xl: 10 }}
          colStart={{ sm: 'main', lg: 'main', xl: 'main' }}
        >
          <TypographyV3
            className="mb-6 uppercase"
            Element="h1"
            variant="body-large"
            weight="bold"
          >
            {t('how_it_works_hero_eyebrow')}
          </TypographyV3>
          <SectionHeading
            animated
            content="how_it_works_hero_title"
            emAnimationProps={{
              transition: { duration: 2, type: 'tween', delay: 0.25 },
              viewport: { once: true },
            }}
            indentation="pl-16 md:pl-24 lg:pl-32 xl:text-right"
            multiline
            typographyProps={{
              className: 'md:justify-start leading-heading tracking-tighter',
              color: 'dark',
              Element: 'h2',
              variant: 'h1',
            }}
            wrapperAnimationProps={{
              initial: { filter: 'blur(5px)', opacity: 0 },
              whileInView: { filter: 'blur(0px)', opacity: 1 },
              viewport: { once: true },
              transition: { duration: 1, type: 'tween' },
            }}
          />
        </GridItem>
        <GridItem
          className="flex flex-col justify-center pt-4 lg:py-32"
          colEnd={{ sm: 'main', lg: 23 }}
          colStart={{ sm: 'main', lg: 15 }}
        >
          <TypographyV3 variant="body-large">
            {t('how_it_works_hero_copy')}
          </TypographyV3>
        </GridItem>
      </LayoutGrid>
    </section>
  );
};

export default HowItWorksHero;
